import React from "react";
import { connect } from "react-redux";
import { Input, Button } from "reactstrap";
import {
    setLoginPage,
    setForgetPasswordDetails,
    setUserRegisterDetails,
    setRegisterDetails,
} from "../../General/Actions";
import Network from "../../Utils/network.js";
import ValidateForm from "../../Utils/formValidation";
import LoadingAnimation from "../../Utils/loadingAnimation.js";
import Swal from "sweetalert2";
import { FaArrowRight } from "react-icons/fa";
import ApuaWhiteTextLogo from "../../ImageAssets/Apua_New_Logo.png";
import blueBanner from "../../ImageAssets/blueBanner.png";

class RechargeAmountComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            verified: false,
            billingName: "NA",
            accountId: "NA",
            paypalClientId: "",
            transactionId: "",
            outstandingAmount: "",
            amount: "",
            diffAmount: "",
            phoneNumber: "NA",
            rechargeDetails: [],
            serviceId: "",
            powertranzOrderId: "", 
            powertranzTransId: "", 
            powertranzInitialResponse: ""
        };
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
        window.removeEventListener("message", this.processIframeMessage);
        clearInterval(this.pollingInterval);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
        window.addEventListener("message", this.processIframeMessage);
        this.populateAccountDetails();
    }

    processIframeMessage = (event) => {
        // console.log("event data >> ", event.data);
        // set interval call status
         setTimeout(() => {
                this.pollingInterval = setInterval(() => this.checkCallbackStatus(event.data.orderId, event.data.transId), 3000);
        }, 2000);
    };

    checkCallbackStatus(orderId,transId) {
        Network.executeAxios("powertranzPaymentComplete", "POST", {orderId : orderId, transId : transId}, (response) => {
            // console.log("response >> ",response);
            if (response.paymentDetails && response.paymentDetails.status !== "INITIATED") {
                console.log("paymentComplete response >> ", response);
                clearInterval(this.pollingInterval);
                var amount = response.paymentDetails.amount;
                var serviceId = response.paymentDetails.serviceId;
                var orderId = response.paymentDetails.orderId;
                if (response.paymentDetails.status === "SUCCESS") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Top up Successful",
                            html:
                                "<div>Your payment for <b>$" +
                                amount +
                                "</b> recharge is successful</div><div><b>$" +
                                amount +
                                "</b> has been added to " +
                                serviceId +
                                "</div><div style='text-align:center'>Order ID: " +
                                orderId +
                                "</div>",
                            type: "",
                            //timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                } else if (response.paymentDetails.status === "FAILED") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Top up Failed",
                            html:
                                "<div>Your payment for $" +
                                amount +
                                " recharge is Failed</div><div style='text-align:center'>Order Id : " +
                                response.paymentDetails.orderId +
                                "</div>",
                            type: "",
                            //timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                } else if (response.paymentDetails.status === "TO_REFUND") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Top up Failed",
                            // html: "<div>Amount debited will be refunded within 2 working days</div>",
                             html:
                                "<div>Your payment for $" +
                                amount +
                                " recharge is Failed</div><div style='text-align:center'>Order Id : " +
                                response.paymentDetails.orderId +
                                "</div>",
                            type: "",
                            //timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                }
            } else {
                console.log("waiting for callback...");
            }
        });
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    };

    populateAccountDetails() {
        if (this.props.userRegisterDetails.accountId) {
            this.setState({ accountId: this.props.userRegisterDetails.accountId });
        }

        if (this.props.userRegisterDetails.billingName) {
            this.setState({ billingName: this.props.userRegisterDetails.billingName });
        }
        if (this.props.userRegisterDetails.serviceId) {
            this.setState({ serviceId: this.props.userRegisterDetails.serviceId });
        }

        var maximumAmountConfig = 0;
        if (
            this.props.configurationValues &&
            this.props.configurationValues.maxRechargeAmount &&
            this.props.configurationValues.maxRechargeAmount > 0
        ) {
            maximumAmountConfig = this.props.configurationValues.maxRechargeAmount;
        }
        //var outstandingAmount = 32
        // try {
        //     outstandingAmount = this.props.userRegisterDetails.accountDetails.balance_details.outstanding_balance
        // } catch (err) {

        // }

        this.setState({
            //amount:  GeneralUtils.formatNumberToStandardForm(outstandingAmount),
            maximumAmountConfig: maximumAmountConfig,
            isLoading: false,
            //outstandingAmount: GeneralUtils.formatNumberToStandardForm(outstandingAmount)
        });
    }

    handleInputValueChange(name, value) {
        if (value !== "") {
            value = parseInt(value);
        }
        if (Number.isInteger(value) || value === "") {
            var isRechargeAmountExists = [];
            for (var i = 0; i < this.state.rechargeDetails.length; i++) {
                if (
                    parseFloat(value) >= this.state.rechargeDetails[i].startRange &&
                    parseFloat(value) <= this.state.rechargeDetails[i].endRange
                ) {
                    isRechargeAmountExists.push("true");
                } else {
                    isRechargeAmountExists.push("false");
                }
            }

            if (isRechargeAmountExists.includes("true")) {
                this.setState({ isRechargeAmountExists: true });
            } else {
                this.setState({ isRechargeAmountExists: false });
            }
            this.setState({
                amount: value,
                diffAmount: value,
                paypalAmount: value,
            });
            var dataToSend = {
                denomination: value,
                rateCardId: this.state.rechargeDetails[0].rateCardId,
                type: "recharge",
            };
            this.props.setRegisterDetails("generalResponse.rechargeDetails", dataToSend);
        }
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    plugNpayBtnClicked() {
        if (parseFloat(this.state.maximumAmountConfig) >= parseFloat(this.state.rechargeAmount)) {
            this.setState({ isLoading: true });
            var dataToSend = {
                amount: this.state.rechargeAmount,
                rateCardId: "12345",
                serviceId: this.state.serviceId,
                billingName: this.state.billingName,
                accountId: this.state.accountId,
                rechargeType: "guest",
            };
            Network.executeAxios("rechargeWithPowertranzWOL", "POST", dataToSend, (Response) => {
                // this.setState({ isLoading: false, plugNPayInitialResponse: Response });
                this.setState({ isLoading: false });
                if(Response.STATUS === "SUCCESS"){
                    // console.log("powertranzInitialResponse >> "+Response.redirectData);
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth' // smooth scroll
                    });
                    this.setState({ 
                        powertranzOrderId: Response.OrderIdentifier, 
                        powertranzTransId: Response.TransactionIdentifier, 
                        powertranzInitialResponse: Response.redirectData 
                    });
                } else {
                    Swal.fire("Please try again later.");
                }

                if (this.props.configurationValues.isPlugNPaySimulatorEnabled === "true") {
                    //simulator
                    Network.executeAxios("paymentResponseUrl", "POST", { orderId: Response.orderId }, (Response) => {
                        Swal.fire({
                            title: "Recharge Successfull",
                            text: "",
                            type: "",
                           // timer: 2000,
                            showCancelButton: false,
                            confirmButtonText: "Ok",
                        }).then((result) => {
                            window.location.reload();
                        });
                    });
                } else {
                    // window.location.replace("./plugNPay.html?responseData=" + encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse)));
                }
            });
        } else {
            Swal.fire(this.props.locales.maxRechargeAmountExceeds);
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    handleInputValueChange(event) {
        const validated = event.target.value.match(/^(\d*\.{0,1}\d{0,2}$)/);
        if (validated) {
            const name = event.target.name;
            const value = event.target.value;
            this.state[name] = value;
        }
        this.setState({ dummy: "dummy" });
    }

    componentContent() {
        const forgetPasswordOuterMainContainerStyle = {
            height: this.state.windowHeight + "px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
        };
        return (
            <div style={forgetPasswordOuterMainContainerStyle} id="RechargeComponentContainer">
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-12 p-0">
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center" }}>
                            {this.rechargeComponent()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPaymentPart = () => {
        return (
            <div className="tsysContainer col-md-12">
                <iframe
                    title="payment"
                    src={
                        "./plugNPay.html?responseData=" +
                        encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse))
                    }
                    style={{ width: "100%", border: "none", height: 1100 }}
                    className=""
                >
                    {" "}
                </iframe>
            </div>
        );
    };

    renderPowertranzPaymentPart = () => {
        return (
            <div className="tsysContainer col-md-12">
                <iframe title="powertranz" 
                    srcDoc={this.state.powertranzInitialResponse} 
                    style={{ width: "100%", border: "none", height:1100 }}>
                    {" "}
                </iframe>
            </div>
        );
    };

    rechargeComponent() {
        return (
            <div className="col-md-12 p-0 m-0" style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                <div
                    className="p-5"
                    style={{
                        backgroundImage: `url(${blueBanner})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100% 100%",
                    }}
                >
                    <div className="pb-5" style={{}}>
                        <img alt="" src={ApuaWhiteTextLogo} />
                    </div>
                </div>

                {this.state.powertranzInitialResponse ? (
                    this.renderPowertranzPaymentPart()
                // {this.state.plugNPayInitialResponse ? (
                //     this.renderPaymentPart()
                ) : (
                    <div className="col-md-12 row m-0 justify-content-center">
                        <div className="col-md-5 col-sm-12 ">
                            <div className="col-md-12" style={{ fontSize: 30, color: "#404042", fontWeight: 400 }}>
                                {this.props.locales.welcomeLabelInRechargeAmountPart} {this.state.serviceId}
                            </div>
                            <div className="rechargeCardDiv p-4 m-3 col-12">
                                <div className="d-flex justify-content-between align-items-center col-md-12 p-0">
                                    <div className="col-md-8 mt-2">
                                        <select
                                            className="form-control input_data rechargeSelectBox"
                                            value={this.state.rechargeAmount}
                                            name="rechargeAmount"
                                            onChange={(event) => this.handleInputValueChange(event)}
                                        >
                                            <option value="">Select the Amount</option>
                                            {this.props.configurationValues.rechargeSuggestionAmounts.map(
                                                (item, key) => {
                                                    return (
                                                        <option key={key} value={item.amount}>
                                                            {item.amount}
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </select>
                                        <div className="errorDesc clearErrorp"></div>
                                    </div>
                                    <div
                                        className="rechargeCardActiveateBtn p-1 px-4 col-md-4"
                                        style={{ height: 40 }}
                                        onClick={() => {
                                            this.plugNpayBtnClicked();
                                        }}
                                    >
                                        Pay
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <input
                                        name="rechargeAmount"
                                        type="text"
                                        className="form-control input_data rechargeTxtBox"
                                        value={this.state.rechargeAmount}
                                        onChange={(event) => this.handleInputValueChange(event)}
                                        style={{ height: 40, fontSize: 14 }}
                                        placeholder="Enter the amount here"
                                    />
                                    <div className="errorDesc clearErrorp"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove("d-none");
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add("d-none");
            event.target.placeholder = placeHolderText;
        }
    }

    signInLinkClicked() {
        this.props.setLoginPage("pageName", "customerIdForOTP");
    }
}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        userRegisterDetails: state.userRegisterDetails,
        configurationValues: state.configurationValues,
        userDetails: state.userDetails,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },

        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload));
        },
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        },
    };
}

const RechargeAmountComponentContainer = connect(mapStateToProps, mapDispatchToProps)(RechargeAmountComponent);

export default RechargeAmountComponentContainer;
